import type { City, ListResponseCity } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed, unref } from "vue";
import citiesService from "@/services/cities.js";

interface Args<TData = City[]> {
  limit: Ref<number> | number;
  skip: Ref<number> | number;
  search?: Ref<string> | string;
  useQueryOptions?: Partial<UseQueryOptions<City[], Error, TData>>;
}

export const useSearchCities = <TData = City[]>({ limit, skip, search, useQueryOptions }: Args<TData>) => {
  const searchCities = (): Promise<ListResponseCity["data"]["items"]> =>
    citiesService
      .searchCities({
        limit: unref(limit),
        skip: unref(skip),
        search: unref(search),
      })
      .then((val: { data: ListResponseCity }) => val?.data?.data?.items);

  return useQuery<City[], Error, TData>({
    queryKey: computed(() => ["searchCities", limit, skip, search]),
    queryFn: searchCities,
    ...useQueryOptions,
  });
};
